import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import LockClosed from "../../icons/lock-closed.svg";
import LockOpened from "../../icons/lock-open.svg";
import { RibbonBadge, TIERS_LIST } from "../RibbonBadge";
export const checkIfTierExists = (tier) => TIERS_LIST.some((tierFromList) => tierFromList === tier.toLowerCase());
export const TierBadge = ({ tier, isAvailable, isIconHidden, className, text }) => {
    const preparedIcon = useMemo(() => {
        if (isIconHidden) {
            return undefined;
        }
        return isAvailable ? LockOpened : LockClosed;
    }, [isAvailable, isIconHidden]);
    const parsedTier = tier?.toLowerCase();
    if (!tier || !checkIfTierExists(parsedTier))
        return null;
    return (_jsx(RibbonBadge, { tier: parsedTier, className: className, icon: preparedIcon, text: text, iconTestId: `tierBadge${isAvailable ? "Available" : "NotAvailable"}` }));
};
//# sourceMappingURL=TierBadge.js.map